import { render, staticRenderFns } from "./NewEndorsementCard.vue?vue&type=template&id=6a2e665c&scoped=true"
import script from "./NewEndorsementCard.vue?vue&type=script&lang=ts"
export * from "./NewEndorsementCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2e665c",
  null
  
)

export default component.exports